import _get from 'lodash.get';
import getBookmakersConfig from '../bookmakersList/bookmakers';
import { actions as bookmakersListActions } from '../bookmakersList';
import executeInWindow from '../utils/executeInWindow';
import ApiClient from '../../common/utils/apiClient';
import updateAuthToken from '../../common/utils/updateAuthToken';
import { deleteLoginCookie } from '../../common/utils/loginCookies';

const bookmakers = getBookmakersConfig();

export const actionTypes = {
    LOGIN_REQUEST: 'LOGIN_REQUEST',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAILURE: 'LOGIN_FAILURE',
    LOGIN_CLEAR_ERROR: 'LOGIN_CLEAR_ERROR',
    REQUEST_BOOKMAKER_LOGIN_INFO: 'REQUEST_BOOKMAKER_LOGIN_INFO',
    REQUEST_BOOKMAKER_LOGIN_INFO_SUCCESS: 'REQUEST_BOOKMAKER_LOGIN_INFO_SUCCESS',
    REQUEST_BOOKMAKER_LOGIN_INFO_ERROR: 'REQUEST_BOOKMAKER_LOGIN_INFO_ERROR',
    SHOW_GDPR_POPUP: 'SHOW_GDPR_POPUP',
};

export const loginSuccess = () => ({
    type: actionTypes.LOGIN_SUCCESS,
});

export const loginFailure = isIncorrectCredentials => ({
    type: actionTypes.LOGIN_FAILURE,
    isIncorrectCredentials,
});

export const loginClearError = () => ({
    type: actionTypes.LOGIN_CLEAR_ERROR,
});

export const requestLogin = (bookie, feed, formData) => (dispatch) => {
    dispatch({ type: actionTypes.LOGIN_REQUEST });

    const { username, password } = formData;
    const body = {
        username,
        password,
    };

    function login() {
        return ApiClient.login(bookie, body)
            .then((res) => {
                updateAuthToken(res.headers);
                if (
                    res.status === 200 &&
                    res.data &&
                    res.data.data &&
                    res.data.data.attributes &&
                    res.data.data.attributes.success
                ) {
                    return res.data.data.attributes;
                }
                return Promise.reject(res);
            })
            .catch((err) => {
                const errors = _get(err, 'response.data.errors', []);
                const isIncorrectCredentials = errors.filter(e =>
                    e.code === '401' || e.detail.indexOf('(code: 10071)') !== -1).length > 0;
                dispatch(loginFailure(isIncorrectCredentials));
                return Promise.reject(err);
            });
    }

    return login().catch(err => Promise.reject({ ...err, retry: login }));
};

export const requestLogout = (bookie, feed, isExternalLogout) => (dispatch) => {
    const logout = (isExternalLogout)
        ? executeInWindow(ApiClient.externalLogout(bookie))
        : ApiClient.logout(bookie);
    const logoutBookmaker = bookmakers.find(bookmaker => bookmaker.feed === feed);

    return logout
        .then((res) => {
            updateAuthToken(res.headers);
            if (
                res.status === 200 &&
                res.data &&
                res.data.data &&
                res.data.data.attributes &&
                res.data.data.attributes.success
            ) {
                deleteLoginCookie(logoutBookmaker.cookieName);
                return dispatch(bookmakersListActions.setLoggedOut(feed));
            }
            return Promise.reject(new Error('Invalid JSON response'));
        })
        .then((result) => {
            const loggedOutEvent = new CustomEvent('BETSLIP.BOOKMAKER.LOGGED_OUT', {
                detail: {},
            });
            document.dispatchEvent(loggedOutEvent);
            return result;
        })
        .catch((err) => {
            const errorCodes = _get(err, 'response.data.errors', []);
            const isUserNotLoggedIn = errorCodes.filter(e => e.code === '401').length > 0;
            const isLogoutError = errorCodes.filter(e => e.code === '400').length > 0;

            if (isUserNotLoggedIn || isLogoutError) {
                deleteLoginCookie(logoutBookmaker.cookieName);
                return dispatch(bookmakersListActions.setLoggedOut(feed));
            }
            return Promise.reject(err);
        })
}

const requestBookmakerInfo = () => ({
    type: actionTypes.REQUEST_BOOKMAKER_LOGIN_INFO,
});

const receiveBookmakerInfoSuccess = () => ({
    type: actionTypes.REQUEST_BOOKMAKER_LOGIN_INFO_SUCCESS,
});

const receiveBookmakerInfoError = () => ({
    type: actionTypes.REQUEST_BOOKMAKER_LOGIN_INFO_ERROR,
});

export const loadBookmakerLoginInfo = (bookmaker, feed) => (dispatch) => {
    dispatch(requestBookmakerInfo())

    return ApiClient.loadBookmakerLoginInfo(bookmaker)
        .then((res) => {
            updateAuthToken(res.headers);
            if (
                res.status !== 200 ||
                !res.data ||
                !res.data.data ||
                !res.data.data.attributes
            ) {
                return Promise.reject(new Error(res.data));
            }
            const auth = {
                authUrl: res.data.data.attributes.bookmaker_url,
            };

            return auth;
        })
        .then((data) => {
            dispatch(receiveBookmakerInfoSuccess());
            dispatch(bookmakersListActions.setAuthInfo(feed, data));
        })
        .catch(() => {
            dispatch(receiveBookmakerInfoError());
            dispatch(bookmakersListActions.setAuthInfo(feed, {
                isError: true,
            }));
        });
};

export const showGdprPopup = url => ({
    type: actionTypes.SHOW_GDPR_POPUP,
    url,
})



// WEBPACK FOOTER //
// /src/js/common/loginPage/login.actions.js